let inject = ['$scope', '$uibModalInstance','modalOptions', '$timeout', 'CartService', 'SessionService'];

class CommentPaymentModalController {
  constructor ($scope,$uibModalInstance,modalOptions, $timeout, CartService, SessionService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.SessionService = SessionService;
    this.CartService = CartService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
    this.comment = this.modalOptions.comment;
    this.maxlengthComment = 150;

  }

  // saveOPaymentComment () {
  //   this.addingCommentCart = true;
  //   this.addedCommentCart = false;
  //   this.errorAddedCommentCart = false;
  //   let data = {
  //     'cartId': 22,
  //     'comment': this.comment
  //   };
  //
  //   this.CartService.updateCommentCart(data).then(response => {
  //     this.addingCommentCart = false;
  //     if (!response.error) {
  //       this.addedCommentCart = true;
  //       this.messageAddedCommentCart = response.message;
  //       this.$timeout(() => {
  //         this.ok();
  //       }, 3000);
  //     }
  //     else {
  //       this.errorAddedCommentCart = true;
  //     }
  //   }).catch(reason => {
  //     this.addingCommentCart = false;
  //     this.addedCommentCart = false;
  //     this.errorAddedCommentCart = true;
  //   });
  //
  // }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.comment);
  }
}

CommentPaymentModalController.$inject = inject;

export default CommentPaymentModalController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/modal-comment-payment/modal-comment-payment.controller.js
 **/